const Footer = () => {
    return (
        <div className="mt-auto text-center bg-black text-slate-400 italic p-2">
            <p>Ghibli Wiki - {new Date().getFullYear()}</p>
        </div>
    )
}
export default Footer